<template>
  <div class="mixed-mode-container" v-visible-track="'Iframe.ancientDnaGeneticSimilaritiesDualOriginPageViewed'">
    <SpinnerContainer v-if="$store.state.mixedModeResult.isLoading"/>
    <template v-if="uiResults && !$store.state.mixedModeResult.isLoading">
      <div class="mixedmode-container-header">
        <div class="update">
        </div>
        <div class="cursor-pointer" @click="geneticFitInfoModal.showModal = true" 
          v-click-track="'Iframe.ancientDnaGeneticSimilaritiesDualOriginTabWhatIsGeneticFitClicked'">      
          <span>{{$tI('Genetic fit wizard popup Screen 1 Title')}}</span>
          <span class="open-info-modal-btn ml-01">
            <InfoIcon />
          </span>
        </div>
      </div>
      <div class="mixed-mode-card cs-scroll-style">
        <div v-for="itemAncestry in uiResults"
            :key="itemAncestry.id" 
            class="mixed-mode-card-item">
          <div class="mixedmode-header">
            <div class="text-number unsupervised-text">
              {{$tI('Model number').replaceAll('{count}', itemAncestry.id + 1)}}
            </div>
            <div class="text-fit">
            {{$tI('Genetic Fit')}}: 
              <span :style="{ color: DistanceColor(itemAncestry.fit) }">{{ itemAncestry.fit }}</span>
            </div>
          </div>
          <div class="mixedmode-body">
            <div class="ancient-mixedmode-item" v-for="itemPop in itemAncestry.pops" :key="itemPop.name" @click="openAncientDetail(itemPop.id)">
              <div class="ancient-left-side">
                <b-media-aside class="mr-auto ancient-img">
                  <b-avatar
                    rounded
                    size="70"
                    :src="itemPop.logoUrl"
                  />
                </b-media-aside>
                <div class="ancient-text-progress ml-2">
                  <div class="text">
                    {{ $tPop(itemPop.name, 'title',  itemPop.name.replaceAll('*', ' ')) }}
                  </div>
                  <div class="progress" :style="{ backgroundColor: ddAlpha(itemPop.color, 0.1) , width: '100%' }">
                    <div class="progress-fill" :style="{ backgroundColor: itemPop.color, width: itemPop.value + '%' }"></div>
                  </div>
                </div>
              </div>

              <div class="ancient-pop">
                {{ itemPop.value }}%
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>

    <GeneticFitInfoModal v-if="geneticFitInfoModal.showModal" :modalObject="geneticFitInfoModal"/>
  </div>
</template>

<script>
import communicationService from '@/services/PostMessageCommunation/CommunicationService';
import dataKeys from '@/services/PostMessageCommunation/enums/DataKeys';

import { DistanceColor } from '@/services/Base/utils'
import InfoIcon from '@/components/icons/InfoIcon.vue';
import GeneticFitInfoModal from '../../Modals/GeneticFitInfoModal.vue';

export default {
  components: {
    InfoIcon,
    GeneticFitInfoModal,
  },
  directives: {
  },
  data() {
    return {
      geneticFitInfoModal: {
        showModal: false,
      },
    }
  },
  methods: {
    DistanceColor,
    ddAlpha(color, opacity) {
      let _opacity = Math.round(Math.min(Math.max(opacity ?? 1, 0), 1) * 255);
      return color + _opacity.toString(16).toUpperCase();
    },

    openAncientDetail(itemId) {
      if (!itemId) {
        return;
      }
      this.$store.dispatch('ancientProxResult/fetchAncientProxDetail', { report: 'DualOrigin', id: itemId });
      this.$store.state.ancientProxResult.isOpenedAncientProxDetail = true;

      communicationService.sendDataToParent({
        key: dataKeys.STATISTICS,
        value: 'Iframe.ancientDnaGeneticSimilaritiesDualOriginTabPopulationClick',
      });
    },
  },
  computed: {
    uiResults() {
      return this.$store.getters['mixedModeResult/getUiResultsTwoWay'];
    },
  },
  mounted() {
  },
}
</script>

